module.exports = __webpack_public_path__ + "static/scully-dee39c19d08086c0f798144265b8ee3f.jpg";